import { ThemeConstellation } from '@zillow/constellation';
import React from 'react';
import { ThemeProvider } from 'styled-components';
import type { FCWithChildren } from '../../types/FCWithChildren';

export const ConstellationThemeProvider: FCWithChildren = ({ children }) => {
  return <ThemeProvider theme={ThemeConstellation as any}>{children}</ThemeProvider>;
};
